import React from 'react'

import { isMobile } from 'react-device-detect'

import { colors } from '@/styles/theme'

import CommonButton from '../form/Button/CommonButton'
import BtnGlobalCustomStyles from '../form/Button/button.customStyles'

interface ButtonProps {
  label: string
  onClick: () => void
  buttonType: 'close' | 'discover'
  style?: any
  dataTestId?: string
}

const Button: React.FC<ButtonProps> = ({
  label,
  onClick,
  buttonType,
  style,
  dataTestId
}) => {
  return (
    <CommonButton
      variant="searchWrapper"
      onClick={onClick}
      buttonType={buttonType}
      style={style}
      data-test-id={dataTestId}
      customStyle={[
        !isMobile && BtnGlobalCustomStyles.popupDesktop,
        BtnGlobalCustomStyles.popup,
        buttonType === 'close'
          ? BtnGlobalCustomStyles.popupDisabled
          : BtnGlobalCustomStyles.popupEnabled
      ]}
    >
      {label}
    </CommonButton>
  )
}

export default Button
